module.exports = __webpack_public_path__ + "img/0040.f75883ae.jpg";